export default function FormCompletionCard() {
    return (
            <div className="text-center">
                <h2 className="text-2xl font-bold mb-4">Well done!</h2>
                <p className="mb-2">You've answered all the questions in this form. Review your answers below.</p>
                <p className="mb-2">If you need to make changes, look for the pencil icon next to each question to edit your answers.</p>
                <p>When you're ready, click the green button in the top right to submit!</p>
            </div>                       
    );
}